import screenerConstants from './screener.json'
import translations from './translations.json'

export {
  translations
}

export const {
  pages,
  epworthOptions,
  symptomOptions,
  coMorbidityData
} = screenerConstants

export const epworthItems = epworthOptions
  .map((label, idx) => ({ option: idx, label }))
